import { FC, ReactNode } from 'react'

import { cn } from '@/app/utils'
import { hexToRgba } from '@/utils/colors'

import styles from './Badge.module.css'
import type { BadgeSizesType, BadgeVariantsType } from './Badge.types'

type Props = {
  variant?: BadgeVariantsType
  size?: BadgeSizesType
  className?: string
  children?: ReactNode | string
  customColor?: string
  disabled?: boolean
}

const Badge: FC<Props> = ({
  variant = 'grey',
  size = 'normal',
  className,
  children,
  customColor,
  disabled = false
}) => {
  return (
    <div
      className={cn(
        'inline-flex max-w-max items-center justify-center whitespace-nowrap rounded-full px-12 py-4 font-bold',
        styles[variant],
        styles[size],
        disabled && 'opacity-50',
        className
      )}
      style={{
        color: customColor,
        backgroundColor: customColor && hexToRgba(customColor, 0.2)
      }}
    >
      {children}
    </div>
  )
}

export default Badge
